"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { Settings, ShieldCheck } from "lucide-react";
import { useTranslations } from "next-intl";
import { buildPageHeaderUtilityActions } from "@components/page/page-header-utility-actions";
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@components/ui/sidebar";
import { useAppSelector } from "@lib/redux/hooks";
import { selectSessionUser } from "@features/application/app-selectors";
import { AccessToken } from "@features/auth/types/access-token";
import routes from "@features/routes";
interface AppSidebarUtilityActionsProps {
  showDesignSystem?: boolean;
  isPrivateMode?: boolean;
}
export const AppSidebarUtilityActions = t0 => {
  const $ = _c(39);
  const {
    showDesignSystem: t1,
    isPrivateMode: t2
  } = t0;
  const showDesignSystem = t1 === undefined ? false : t1;
  const isPrivateMode = t2 === undefined ? false : t2;
  const user = useAppSelector(selectSessionUser);
  let t3;
  if ($[0] !== user) {
    t3 = AccessToken.isGlobalAdmin(user ?? undefined);
    $[0] = user;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const isGlobalAdmin = t3;
  const t = useTranslations("features.auth.ui.nav-user");
  let T0;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[2] !== isGlobalAdmin || $[3] !== isPrivateMode || $[4] !== showDesignSystem || $[5] !== t) {
    const utilityActions = buildPageHeaderUtilityActions({
      showDesignSystem
    });
    t7 = "app-sidebar-utility-actions";
    T0 = SidebarMenu;
    let t8;
    if ($[11] !== t) {
      t8 = t("settings");
      $[11] = t;
      $[12] = t8;
    } else {
      t8 = $[12];
    }
    let t9;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = routes.personal_access_tokens.pages.owner.path();
      $[13] = t9;
    } else {
      t9 = $[13];
    }
    let t10;
    if ($[14] !== t) {
      t10 = t("settings");
      $[14] = t;
      $[15] = t10;
    } else {
      t10 = $[15];
    }
    let t11;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <Settings aria-hidden="true" />;
      $[16] = t11;
    } else {
      t11 = $[16];
    }
    let t12;
    if ($[17] !== t) {
      t12 = t("settings");
      $[17] = t;
      $[18] = t12;
    } else {
      t12 = $[18];
    }
    let t13;
    if ($[19] !== t12) {
      t13 = <span>{t12}</span>;
      $[19] = t12;
      $[20] = t13;
    } else {
      t13 = $[20];
    }
    let t14;
    if ($[21] !== t10 || $[22] !== t13) {
      t14 = <Link href={t9} aria-label={t10}>{t11}{t13}</Link>;
      $[21] = t10;
      $[22] = t13;
      $[23] = t14;
    } else {
      t14 = $[23];
    }
    if ($[24] !== t14 || $[25] !== t8) {
      t4 = <SidebarMenuItem><SidebarMenuButton asChild={true} tooltip={t8}>{t14}</SidebarMenuButton></SidebarMenuItem>;
      $[24] = t14;
      $[25] = t8;
      $[26] = t4;
    } else {
      t4 = $[26];
    }
    if ($[27] !== isGlobalAdmin || $[28] !== isPrivateMode || $[29] !== t) {
      t5 = isPrivateMode && isGlobalAdmin && <SidebarMenuItem><SidebarMenuButton asChild={true} tooltip={t("administration")}><Link href={routes.personal_access_tokens.pages.admin.path()} aria-label={t("administration")}><ShieldCheck aria-hidden="true" /><span>{t("administration")}</span></Link></SidebarMenuButton></SidebarMenuItem>;
      $[27] = isGlobalAdmin;
      $[28] = isPrivateMode;
      $[29] = t;
      $[30] = t5;
    } else {
      t5 = $[30];
    }
    t6 = utilityActions.map(_temp);
    $[2] = isGlobalAdmin;
    $[3] = isPrivateMode;
    $[4] = showDesignSystem;
    $[5] = t;
    $[6] = T0;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    T0 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
  }
  let t8;
  if ($[31] !== T0 || $[32] !== t4 || $[33] !== t5 || $[34] !== t6) {
    t8 = <T0>{t4}{t5}{t6}</T0>;
    $[31] = T0;
    $[32] = t4;
    $[33] = t5;
    $[34] = t6;
    $[35] = t8;
  } else {
    t8 = $[35];
  }
  let t9;
  if ($[36] !== t7 || $[37] !== t8) {
    t9 = <div data-testid={t7}>{t8}</div>;
    $[36] = t7;
    $[37] = t8;
    $[38] = t9;
  } else {
    t9 = $[38];
  }
  return t9;
};
function _temp(action) {
  return <SidebarMenuItem key={action.id}><SidebarMenuButton asChild={true} tooltip={action.label}><Link href={action.href} aria-label={action.ariaLabel}><action.Icon aria-hidden="true" /><span>{action.label}</span></Link></SidebarMenuButton></SidebarMenuItem>;
}